module.exports = __webpack_public_path__ + "img/excel.74a205f3.png";